/** High-level, grouped UI that renders an OfferResponseFilterPanel
 * for every OfferGroup in a given OfferResponse.
 * This facilitates a single, dock-able filter component with
 * filters for all the separate legs. In order to facilitate this, the
 * actual filter functions are stored outside of this component, with
 * a callback provided to update a particular filter.
 */

import React from 'react'
import { List, Map } from 'immutable'
import classnames from 'classnames'
import OfferResponseFilterPanel from './OfferResponseFilterPanel'
import './OfferResponseFilterPanel.css'
import OfferGroupHeading from './OfferGroupHeading'

const OfferGroupsFilterPanels = ({
    offerGroups = List(),
    visible = true,
    updateFilter,
    view
 }) =>
    <div id="filters"
        className={classnames({
            filters: true,
            collapse: visible,
            in: visible
        })}
        style={{
            display: visible
                ? 'block'
                : 'none'
        }
        }>
        {offerGroups.map((og = Map(), i) =>
            <OfferResponseFilterPanel
                key={i}
                requested={og.get('requested')}
                offers={og.get('offer')}
                onFilter={f => updateFilter(i, f)}
                view = {view}>
                <OfferGroupHeading index={i} offerGroup={og} view={view}/>
            </OfferResponseFilterPanel>
        )}
    </div>


export default OfferGroupsFilterPanels



// WEBPACK FOOTER //
// ./src/ndc/offer/OfferGroupsFilterPanels.js